<template>
  <div>
    <!-- 顶部 -->
    <detailHeader />
    <div class="content">
      <!--群发信息  -->
      <h1>{{ $t("message.massMessaging") }}</h1>
      <el-form :model="datas" :rules="rules" ref="datas" label-width="150px" class="demo-ruleForm">
        <!-- 通告群体： -->
        <el-form-item :label="$t('message.noticeGroup') + ':'" prop="group_type">
          <el-select v-model="datas.group_type" placeholder="请选择" @change="changeNange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 人员选择 -->
        <el-form-item :label="$t('message.personnelSelection') + ':'" v-if="datas.group_type == '20'">
          <div class="value">
            <div class="button">
              <!-- 选择 -->
              <el-button type="primary" class="primary" @click="choose">
                {{ $t("message.choose") }}
              </el-button>
            </div>
            <!-- 部分客户 -->
            <div class="table" v-if="datas.group_type == '20'">
              <el-table :data="selectedPersonnel" :default-sort="{ prop: 'date', order: 'descending' }"
                :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" max-height="400px">
                <el-table-column align="center" type="index" width="80" label="NO">
                </el-table-column>
                <!-- 客户ID -->
                <el-table-column align="center" :label="$t('message.clientID')" prop="id">
                </el-table-column>
                <!-- 客户名称 -->
                <el-table-column align="center" :label="$t('message.userName')" prop="realname">
                </el-table-column>
                <!-- 删除 -->
                <el-table-column :label="$t('message.delete')" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="delSelectedPersonnel(scope.row.id)">
                      {{ $t("message.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

          </div>
        </el-form-item>
        <!-- 通知内容 -->
        <el-form-item :label="$t('message.noticeContent') + ':'" prop="content">
          <el-input type="textarea" v-model="datas.content"></el-input>

        </el-form-item>
        <!-- 定时发送时间： -->
        <el-form-item :label="$t('message.timedTransmissionTime') + ':'">
          <el-date-picker v-model="datas.send_date" type="datetime" :placeholder="$t('message.timedTransmissionTime')"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <!-- 图片 -->
        <el-form-item :label="$t('message.pic') + ':'">
          <el-upload class="avatar-uploader" action="https://apimanage.rakumart.com/api/common/uploadFile"
            :on-success="avatarSuccess" list-type="picture-card" :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove" :show-file-list="false" drag>
            <img v-if="datas.image" :src="datas.image" class="avatar" style="width: 120px;height: 120px;">
            <i class="el-icon-picture-outline avatar-uploader-icon" v-else></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- 预览 -->
      <div class="btn">
        <!-- 保存 -->
        <el-button type="primary" @click="templateSave">
          {{ $t("message.save") }}
        </el-button>
        <!--取 消  -->
        <el-button type="primary" class="dark">
          {{ $t("message.cancel") }}
        </el-button>
      </div>
    </div>
    <!-- 人员选择 -->
    <el-dialog :title="$t('message.personnelSelection')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="800px" center>
      <div class="body">
        <div class="search">
          <!-- 客户ID： -->
          <div class="label">
            {{ $t("message.clientID") }}:
          </div>
          <!--搜索  -->
          <div class="value">
            <el-input v-model="personnelData.user_id" onfocus="this.select()" clearable></el-input>
          </div>
          <div class="value">
            <el-select v-model="personnelData.section" placeholder="请选择部门" clearable>
              <el-option label="一部" value="一部">
              </el-option>
              <el-option label="二部" value="二部">
              </el-option>
              <el-option label="三部" value="三部">
              </el-option>
            </el-select>
          </div>
          <!-- 查询 -->
          <div class="label" style="width: 60px;">
            <el-button type="primary" @click="personnelInquiry">
              {{ $t("message.inquire") }}
            </el-button>
          </div>
        </div>
        <el-table :data="user_data" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
          <!-- 客户ID -->
          <el-table-column prop="id" :label="$t('message.clientID')" align="center">
          </el-table-column>
          <!--客户名称-->
          <el-table-column prop="realname" :label="$t('message.customerName')" align="center">
          </el-table-column>
          <!-- 删除 -->
          <el-table-column align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="delItem(scope.row.id)">
                {{ $t("message.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="picDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    detailHeader,
    quillEditor,
  },
  data() {
    return {
      datas: {
        content: "",
        group_type: "", //10-全部客户,11-部分客户,20-全部管理员,21-部分管理员
        user_data: [],
        send_date: "",
        image: '',
      },
      dialogImageUrl: '',
      picDialogVisible: false,
      rules: {
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        group_type: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
      options: [
        {
          label: "全部有CW群组客户",
          value: "10",
        },
        {
          label: "指定cw客户",
          value: "20",
        },

      ],
      quillOption: quillConfig,
      //   人员选择
      dialogVisible: false,
      selectedPersonnel: [],
      user_data: [],
      personnelData: {
        user_id: "",
        section: "",
      },
    };
  },
  methods: {
    onEditorChange(e) {
      console.log(e);
    },
    //状态筛选
    changeNange(e) {
      this.selectedPersonnel = [];
    },
    // 选择
    choose() {
      this.user_data = [];
      this.personnelData.user_id = "";
      this.personnelData.section = "";
      this.dialogVisible = true;
    },
    //人员搜索
    personnelInquiry() {
      this.$api.noticeApi
        .personnelInquiry(this.personnelData)
        .then((res) => {
          this.user_data = [... this.user_data, ...res.data]
          var hash = {};
          this.user_data = this.user_data.reduce(function (item, next) {
            hash[next.id]
              ? ""
              : (hash[next.id] = true && item.push(next));

            return item;
          }, []);
        });
    },
    // 删除未选择人员
    delItem(id) {
      let index = this.user_data.findIndex((item) => item.id == id);
      this.user_data.splice(index, 1);
    },
    //删除已选择的
    delSelectedPersonnel(id) {
      let index = this.selectedPersonnel.findIndex((item) => item.id == id);
      this.selectedPersonnel.splice(index, 1);
    },
    //人员保存
    save() {
      this.selectedPersonnel = [...this.selectedPersonnel, ...this.user_data];
      this.dialogVisible = false;
    },
    // 上传成功
    avatarSuccess(res,) {
      this.datas.image = res.data
    },
    // 删除
    handleRemove(file, fileList) {
      this.images = fileList
    },
    // 查看大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.picDialogVisible = true
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个图片，本次选择了 ${files.length} 个图片，共选择了 ${files.length + fileList.length} 个图片`);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      // this.loading = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        // this.loading = false;
      }
      return isJPG || isPNG;
    },
    //群发消息模版添加
    templateSave() {
      this.$refs.datas.validate((valid) => {
        if (valid) {
          this.datas.user_data = this.selectedPersonnel
          this.$api.noticeApi.templateSave(this.datas).then((res) => {
            this.$message.success(res.msg);
            this.$router.push("/menu3_config_notice?activeName=2");
          });
        }
      });


    },
  },
};
</script>
<style lang='scss' scoped>
h1 {
  font-size: 25px;
  font-weight: 600;
  margin: 0 0 40px;
  text-align: center;
}

.content {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;
  min-width: 1814px;

  .value {
    flex: 1;
    display: flex;

    .button {
      width: 100px;
      margin-right: 40px;
    }

    .table {
      width: 500px;
    }
  }

  /deep/.el-form-item__label {
    font-size: 20px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }
}

/deep/.el-textarea__inner {
  min-height: 300px !important;
}

.search {
  display: flex;
  margin-bottom: 20px;
  line-height: 40px;

  .label {
    width: 120px;
    text-align: right;
  }

  .value {
    flex: 1;
    margin: 0 30px;
  }
}

.btn {
  text-align: center;
}

/deep/.el-upload {
  border: none;
}

/deep/.el-upload-dragger {
  width: 120px !important;
  height: 120px !important;
}
</style>